export const INSTRUCTION_TAGS = [
  { id: "before_8am", label: "Before 8 am", group: "time", window: [0, 8] },
  { id: "morning", label: "Morning only", group: "time", window: [6, 12] },
  { id: "midday", label: "Mid-day", group: "time", window: [11, 15] },
  { id: "evening", label: "Evening", group: "time", window: [17, 21] },
  { id: "after_5pm", label: "After 5 pm", group: "time", window: [17, 24] },
  { id: "no_sunday", label: "No Sunday service", group: "rule" },
  { id: "no_posting", label: "No posting", group: "rule" },
  { id: "no_doorhanger", label: "Do not leave doorhanger", group: "rule" },
  { id: "personal_only", label: "Personal service only", group: "rule" },
  { id: "no_substitute", label: "No substitute service", group: "rule" },
  { id: "substitute_ok", label: "Substitute service OK", group: "rule" },
  { id: "nail_and_mail", label: "Nail and mail", group: "rule" },
  { id: "post_after_first", label: "Post after 1st attempt", group: "rule" },
  { id: "two_attempts_post", label: "Post after 2nd attempt", group: "rule" },
  { id: "military_status", label: "Ask military status", group: "ask" },
  { id: "marital_status", label: "Ask marital status", group: "ask" },
  { id: "signature_required", label: "Signature required", group: "ask" },
  { id: "photos_required", label: "Photo(s) required", group: "ask" },
  { id: "date_time_summons", label: "Date, time, initial summons", group: "ask" },
];
export const TAG_LABEL = Object.fromEntries(INSTRUCTION_TAGS.map((t) => [t.id, t.label]));
export const TAG_STYLE = { time: "bg-sky-100 text-sky-900 border-sky-200", rule: "bg-amber-100 text-amber-900 border-amber-200", ask: "bg-violet-100 text-violet-900 border-violet-200" };
export const tagGroup = (id) => INSTRUCTION_TAGS.find((t) => t.id === id)?.group || "rule";

/** Client-portal quick picks: label shown on the bubble, sentence inserted, tag(s) applied to the job. */
export const QUICK_INSTRUCTIONS = [
  { label: "No Sunday Service", text: "No Sunday service.", tags: ["no_sunday"] },
  { label: "No Substitute Service", text: "No substitute service — personal service only.", tags: ["no_substitute", "personal_only"] },
  { label: "Substitute Service OK", text: "Substitute service OK.", tags: ["substitute_ok"] },
  { label: "Must Ask Military Status", text: "Must ask military status.", tags: ["military_status"] },
  { label: "Must Ask Marital Status", text: "Must ask marital status.", tags: ["marital_status"] },
  { label: "Post After 2nd Attempt", text: "Post after 2nd attempt.", tags: ["two_attempts_post"] },
  { label: "Post After 1st Attempt", text: "Post after 1st attempt.", tags: ["post_after_first"] },
  { label: "Signature Required", text: "Signature required.", tags: ["signature_required"] },
];

/** Earliest hour (0-24) a job may be attempted today given its time tags; null = anytime. */
export const jobWindow = (job) => {
  const wins = (job.instruction_tags || []).map((id) => INSTRUCTION_TAGS.find((t) => t.id === id)?.window).filter(Boolean);
  if (!wins.length) return null;
  return [Math.min(...wins.map((w) => w[0])), Math.max(...wins.map((w) => w[1]))];
};
